//Libs
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Local
import { DbRead } from "../../database";
import { useSiteKeyDocStore } from "../../store/site-key-doc";
import { useUserPermissionsStore } from "../../store/user-permissions";
import { useUserDisplayNamesStore } from "../../store/user-display-names-map";
import LoadingClipboardAnimation from "../../components/LoadingClipBoardAnimation";
import { ExistingProject } from "../../models/project";
import ProjectsListPage from "./ProjectsListPage";

interface Props {
  siteKey: string;
}

export default function ProjectsListContainer({ siteKey }: Props) {
  const navigate = useNavigate();
  const [userDisplayNamesMap, userDisplayNamesMapIsLoading] =
    useUserDisplayNamesStore((state) => [
      state.userDisplayNames,
      state.loading,
    ]);

  const userPermissions = useUserPermissionsStore(
    (state) => state.siteKeyUserPermissions,
  );

  const [siteKeyDoc, siteKeyDocIsLoading] = useSiteKeyDocStore((state) => [
    state.siteKeyDoc,
    state.loading,
  ]);

  const [projects, setProjects] = useState<ExistingProject[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!userPermissions || !siteKeyDoc) return undefined;

    setIsLoading(true);

    const unsubscribe = DbRead.projects.subscribeAll(
      siteKey,
      (projectList) => {
        setProjects(projectList);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching projects:", error);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [siteKey, userPermissions, siteKeyDoc]);

  function goToProjectDetailsPage(projectID: string) {
    navigate(`/projects/${projectID}`);
  }

  // RENDER LOADING
  if (
    isLoading ||
    userDisplayNamesMapIsLoading ||
    siteKeyDocIsLoading ||
    !userPermissions
  ) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <LoadingClipboardAnimation />
      </div>
    );
  }

  // RENDER CONTENT
  return (
    <Fragment>
      <ProjectsListPage
        projects={projects.sort(
          (a, b) =>
            b.timestampCreated.toMillis() - a.timestampCreated.toMillis(),
        )}
        userDisplayNamesMap={userDisplayNamesMap}
        goToProjectDetailsPage={goToProjectDetailsPage}
      />
    </Fragment>
  );
}
